import useLoad from 'components/hooks/useLoad';
import {requirement} from 'constants/url';

function useLoadRequirement() {
  return useLoad(requirement, ['iD_Course', 'iD_Profile', 'iD_Sector'], {
    additional: 'query',
  });
}

export default useLoadRequirement;
